module.exports = "https://cdn-shared.mathletics.com/mathsaz/100/assets/images/24147e4f356ef55d19d84b8d98c7fabd.svg";